import { render, staticRenderFns } from "./ListB.vue?vue&type=template&id=74f7ce1a"
import script from "./ListB.vue?vue&type=script&lang=js"
export * from "./ListB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports